namespace $.$$ {
	$mol_style_define($bog_formigo_filler, {
		Body_content: {
			padding: $mol_gap.block,
		},

		Nav: {
			gap: '1rem',
		},

		Step_counter: {
			opacity: 0.6,
		},

		Progress: {
			opacity: 0.6,
			font: {
				size: '.85rem',
			},
		},
	})
}
